import React from 'react';
import { MEMBERS_ANALYTICS_ICON_SVGS } from './membersAnalyticsIconAssets';

const CATEGORY_ICON_IDS: Record<string, string> = {
  exercise: 'exercise',
  education: 'holistic-wellness',
  social: 'social',
  nutrition: 'nutrition',
  achievement: 'awards',
};

interface IProps {
  className?: string;
}

function MembersAnalyticsInlineIcon({ iconId, className }: { iconId: string, className?: string }) {
  const svg = MEMBERS_ANALYTICS_ICON_SVGS[iconId];
  if (!svg) {
    return null;
  }
  return (
    <span
      aria-hidden
      className={className}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}

export function CategoryAnalyticsIcon({ categoryId, className }: { categoryId: string, className?: string }) {
  const iconId = CATEGORY_ICON_IDS[categoryId];
  if (!iconId) {
    return null;
  }
  return <MembersAnalyticsInlineIcon className={className} iconId={iconId} />;
}

export function StepsAnalyticsIcon({ className }: IProps) {
  return <MembersAnalyticsInlineIcon className={className} iconId='steps' />;
}

export function WorkoutsAnalyticsIcon({ className }: IProps) {
  return <MembersAnalyticsInlineIcon className={className} iconId='workouts' />;
}
